(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-type', {
            parent: 'entity',
            url: '/customer-type?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.customerType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-type/customer-types.html',
                    controller: 'CustomerTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('customer-type-detail', {
            parent: 'entity',
            url: '/customer-type/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.customerType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-type/customer-type-detail.html',
                    controller: 'CustomerTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomerType', function($stateParams, CustomerType) {
                    return CustomerType.get({id : $stateParams.id});
                }]
            }
        })
        .state('customer-type.new', {
            parent: 'customer-type',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-type/customer-type-dialog.html',
                    controller: 'CustomerTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('customer-type', null, { reload: true });
                }, function() {
                    $state.go('customer-type');
                });
            }]
        })
        .state('customer-type.edit', {
            parent: 'customer-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-type/customer-type-dialog.html',
                    controller: 'CustomerTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomerType', function(CustomerType) {
                            return CustomerType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer-type.delete', {
            parent: 'customer-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-type/customer-type-delete-dialog.html',
                    controller: 'CustomerTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomerType', function(CustomerType) {
                            return CustomerType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
